<template>
  <div id="mainmenu-div">
    <nav class="dropdownmenu">
      <ul class="mainmenu">
        <li @click="pathPlan" class="menu-item-t">
          <img class="li-img" src="../../assets/hx.png" />
          航线规划
        </li>
        <li @click="openFXJK" class="menu-item-t">
          <img class="li-img" src="../../assets/fx.png" />
          飞行监控
        </li>
        <li @click="openZHDD" class="menu-item-t">
          <img class="li-img" src="../../assets/zh.png" />
          指挥调度
        </li>
        <li @click="layerManage" class="menu-item-t line-color">
          <img class="li-img" src="../../assets/tcgl.png" />
          图层管理
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import vectorPlot from "../VectorPlot/index.vue"; //矢量标绘
// import militaryPlot from "../SvgPlot/index.vue"; //军事标绘
import militaryPlot from "../MilitaryPlot/index.vue"; //军事标绘
import listPlot from "../VectorPlot/list.vue"; //军事标绘

import spatialMeasure from "../SpatialMeasure/index.vue"; //空间测量
import spatialAnalysis from "../SpatialAnalysis/index.vue"; //空间分析
import layerManage from "../Layer/index.vue"; //图层管理

//北斗指挥开始
import carTree from "../carTree/index.vue"; //监控中心
import carTreeJK from "../carTree/JK.vue"; //监控中心
import mesTabs from "../mesTabs/index.vue"; //实时通讯
import Commrecord from "@/views/commrecord/index.vue"; //历史通讯
import Locations from "@/views/locations/index.vue"; //轨迹信息
import Cards from "@/views/cards/index.vue"; //设备管理
import Fence from "@/views/fence/index.vue"; //电子围栏管理
import equipmentDic from "@/views/equipmentDic/index.vue"; //装备字典管理
import maintenanceManage from "@/views/maintenanceManage/index.vue"; //维修任务管理
import flagplaneMsg from "@/views/flagplane/index.vue"; //指挥机信息
import shipTypeManage from "@/views/shipType/index";
//北斗指挥结束

import seaRescue from "@/components/SeaRescue/index.vue"; //海上救援
import flightRoam from "@/components/FlightRoam/index.vue"; //飞行漫游
import keyboardRoam from "@/components/keyboardRoam/index.vue"; //键盘漫游
//import basePlot from "../SvgPlot/base.vue";
// import spatialMeasure from "../Analysis/spatialMeasure.vue";
//import spatialAnalysis from "../Analysis/spatialAnalysis.vue";
import Effect from "../Effect/index.vue";
import ViewShed from "@/utils/cesiumBD/analysis/viewShed/ViewShed.js";
import Bookmark from "../Bookmark/index.vue"; //书签管理
import LocationPos from "../LocationPos/index.vue"; //坐标定位
import ModelEdit from "../ModelEdit/index.vue"; //模型编辑
import VideoProjection from "../VideoProjection/index.vue"; //视频融合
import SkinSetting from "../SkinSetting/index.vue"; //系统皮肤设置
import PlanEditor from "../PlanEditor/index.vue"; //预案编辑
import PlanList from "../PlanEditor/list.vue"; //预案编辑
import Pathplan from "../Roads/index.vue"; //预案编辑
import Pathplan2 from "../Roads/pathplan2.vue"; //预案编辑

import videoTimeLine from "@/components/PlanEditor/videoTimeLine.vue";
import { removeToken } from "@/utils/auth";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    var menus = document.querySelectorAll("#mainmenu-div");
    var head = document.querySelectorAll(".bd-head");
    menus.forEach((menu) => {
      // 监听鼠标移入事件
      menu.addEventListener("mouseenter", function (event) {
        // 在这里执行鼠标移入时的操作
        head[0].style.zIndex = "9999999";
      });

      // 监听鼠标移出事件
      menu.addEventListener("mouseleave", function (event) {
        head[0].style.zIndex = "1";
        // 在这里执行鼠标移出时的操作
      });
    });
  },
  methods: {
    openFXJK() {
      var ins = this.$dialog.getDialog("飞行监控");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "飞行监控",
        title: "飞行监控",
        theme: "feature-dialog",
        area: {
          height: "826px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: carTreeJK,
        },
      });
    },
    openZHDD() {
      var ins = this.$dialog.getDialog("指挥调度");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "指挥调度",
        title: "指挥调度",
        theme: "feature-dialog",
        area: {
          height: "826px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: carTree,
        },
      });
    },
    timeLine() {
      //videoTimeLine

      this.$dialog.open({
        id: "动态时间轴",
        title: "动态时间轴",
        theme: "feature-dialog",
        area: {
          height: "240px",
          width: "100vw",
        },
        location: {
          top: undefined,
          left: undefined,
          bottom: "20px",
          right: "0",
        },
        content: {
          type: "vue",
          subCom: videoTimeLine,
        },
      });
    },
    doLoginOut() {
      removeToken();
      this.$dialog.closeAll();
      this.$router.push({ path: "/" });
    },
    pathPlan2() {
      this.$dialog.open({
        id: "路径规划(离线)",
        title: "路径规划(离线)",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "500px",
        },
        location: {
          top: undefined,
          left: undefined,
          bottom: "40px",
          right: "20px",
        },
        content: {
          type: "vue",
          subCom: Pathplan2,
        },
      });
    },
    pathPlan() {
      this.$dialog.open({
        id: "航线规划",
        title: "航线规划",
        theme: "feature-dialog",
        area: {
          height: "826px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Pathplan,
        },
      });
    },
    //我的标绘
    myPlot() {
      var ins = this.$dialog.getDialog("我的标绘");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "我的标绘",
        title: "我的标绘",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "500px",
        },
        location: {
          top: undefined,
          left: undefined,
          bottom: "40px",
          right: "20px",
        },
        content: {
          type: "vue",
          subCom: listPlot,
        },
      });
    },
    //预案推演
    planList() {
      var ins = this.$dialog.getDialog("预案推演");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "预案推演",
        title: "预案推演",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "600px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: PlanList,
        },
      });
    },
    //预案编辑
    planEditor() {
      var ins = this.$dialog.getDialog("预案编辑");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "预案编辑",
        title: "预案编辑",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "600px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: PlanEditor,
        },
      });
    },

    //皮肤设置
    skinSetting() {
      var ins = this.$dialog.getDialog("皮肤设置");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "皮肤设置",
        title: "皮肤设置",
        theme: "feature-dialog",
        area: {
          height: "150px",
          width: "400px",
        },
        content: {
          type: "vue",
          subCom: SkinSetting,
        },
      });
    },
    flagplaneMsg() {
      var ins = this.$dialog.getDialog("指挥机信息");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "指挥机信息",
        title: "指挥机信息",
        theme: "feature-dialog",
        area: {
          height: "520px",
          width: "800px",
        },
        content: {
          type: "vue",
          subCom: flagplaneMsg,
        },
      });
    },
    seaRescue() {
      var ins = this.$dialog.getDialog("海上应急");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "海上应急",
        title: "海上应急",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: seaRescue,
        },
      });
    },
    //模型编辑
    modelEdit() {
      var ins = this.$dialog.getDialog("模型编辑");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "模型编辑",
        title: "模型编辑",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: ModelEdit,
        },
      });
    },
    //键盘漫游
    keyboardRoam() {
      var ins = this.$dialog.getDialog("键盘漫游");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "键盘漫游",
        title: "键盘漫游",
        theme: "feature-dialog",
        area: {
          height: "500px",
          width: "360px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: keyboardRoam,
        },
      });
    },
    //视频融合
    videoProjection() {
      var ins = this.$dialog.getDialog("视频融合");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "视频融合",
        title: "视频融合",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: VideoProjection,
        },
      });
    },
    //坐标定位
    locationPos() {
      var ins = this.$dialog.getDialog("坐标定位");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "坐标定位",
        title: "坐标定位",
        theme: "feature-dialog",
        area: {
          height: "400px",
          width: "360px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: LocationPos,
        },
      });
    },
    //飞行漫游
    flightRoam() {
      var ins = this.$dialog.getDialog("飞行漫游");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "飞行漫游",
        title: "飞行漫游",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: flightRoam,
        },
      });
    },
    viewShedShow() {
      new ViewShed(viewer, {
        viewPosition: Cesium.Cartesian3.fromDegrees(-120.0, 40.0),
        viewPositionEnd: Cesium.Cartesian3.fromDegrees(-120.0, 50.0),
      });
    },
    shipTypeManage() {
      var ins = this.$dialog.getDialog("舰船型号管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "舰船型号管理",
        title: "舰船型号管理",
        theme: "feature-dialog",
        area: {
          height: "760px",
          width: "800px",
        },
        content: {
          type: "vue",
          subCom: shipTypeManage,
        },
      });
    },
    maintenanceManage() {
      var ins = this.$dialog.getDialog("维修任务管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "维修任务管理",
        title: "维修任务管理",
        theme: "feature-dialog",
        area: {
          height: "760px",
          width: "1200px",
        },
        // location: {
        //     top: "100px",
        // },
        content: {
          type: "vue",
          subCom: maintenanceManage,
        },
      });
    },
    equipmentDicManage() {
      var ins = this.$dialog.getDialog("装备字典管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "装备字典管理",
        title: "装备字典管理",
        theme: "feature-dialog",
        area: {
          height: "760px",
          width: "900px",
        },
        // location: {
        //     top: "110px",
        // },
        content: {
          type: "vue",
          subCom: equipmentDic,
        },
      });
    },
    timeCommunicate() {
      this.$dialog.open({
        title: "实时通讯",
        area: {
          height: "260px",
          width: "calc(100vw - 320px)",
        },
        location: {
          bottom: "16px",
          right: "0px",
        },
        content: {
          type: "vue",
          subCom: mesTabs,
        },
      });
    },
    monitorCenter() {
      var ins = this.$dialog.getDialog("监控中心");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "监控中心",
        title: "监控中心",
        theme: "feature-dialog",
        area: {
          height: "826px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: carTree,
        },
      });
    },
    //设备管理
    cardsManage() {
      var ins = this.$dialog.getDialog("设备管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "设备管理",
        title: "设备管理",
        theme: "feature-dialog",
        area: {
          height: "520px",
          width: "800px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Cards,
        },
      });
    },
    //电子围栏管理Fence
    fenceManage() {
      var ins = this.$dialog.getDialog("电子围栏管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "电子围栏管理",
        title: "电子围栏管理",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Fence,
        },
      });
    },
    //通讯记录
    commrecord() {
      var ins = this.$dialog.getDialog("历史通讯");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "历史通讯",
        title: "历史通讯",
        theme: "feature-dialog",
        area: {
          height: "520px",
          width: "1200px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Commrecord,
        },
      });
    },
    //轨迹信息
    carLocation() {
      var ins = this.$dialog.getDialog("轨迹信息");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "轨迹信息",
        title: "轨迹信息",
        theme: "feature-dialog",
        area: {
          height: "520px",
          width: "1200px",
        },
        location: {
          top: "100px",
        },
        content: {
          type: "vue",
          subCom: Locations,
        },
      });
    },
    //矢量标绘
    vectorPlot() {
      var ins = this.$dialog.getDialog("矢量标绘");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "矢量标绘",
        theme: "feature-dialog",
        title: "矢量标绘",
        area: {
          height: "140px",
          width: "70vw", //"1400px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: vectorPlot,
        },
      });
    },

    //军事标绘
    militaryPlot() {
      var ins = this.$dialog.getDialog("军事标绘");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "军事标绘",
        title: "军事标绘",
        theme: "feature-dialog",
        area: {
          height: "70vh", //"800px",
          width: "300px",
        },
        location: {
          top: undefined,
          left: undefined,
          bottom: "40px",
          right: "20px",
        },
        content: {
          type: "vue",
          subCom: militaryPlot,
        },
      });
    },
    spatialMeasure() {
      var ins = this.$dialog.getDialog("空间测量");
      if (ins) {
        ins.reset();
        return;
      }

      this.$dialog.open({
        id: "空间测量",
        title: "空间测量",
        theme: "feature-dialog",
        area: {
          height: "140px",
          width: "70vw", //"1400px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: spatialMeasure,
        },
      });
    },
    spatialAnalysis() {
      var ins = this.$dialog.getDialog("空间分析");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "空间分析",
        title: "空间分析",
        theme: "feature-dialog",
        area: {
          height: "140px",
          width: "70vw", //"1400px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: spatialAnalysis,
        },
      });
    },
    specialEffect() {
      this.$dialog.open({
        title: "三维特效",
        area: {
          height: "840px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Effect,
        },
      });
    },
    //图层管理
    layerManage() {
      var ins = this.$dialog.getDialog("图层管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "图层管理",
        title: "图层管理",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: layerManage,
        },
      });
    },
    bookManage() {
      var ins = this.$dialog.getDialog("书签管理");
      if (ins) {
        ins.reset();
        return;
      }
      this.$dialog.open({
        id: "书签管理",
        title: "书签管理",
        theme: "feature-dialog",
        area: {
          height: "800px",
          width: "300px",
        },
        location: {
          top: "80px",
          left: "20px",
        },
        content: {
          type: "vue",
          subCom: Bookmark,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdownmenu .mainmenu {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.dropdownmenu ul {
  list-style: none;
  width: 100%;
}

// .dropdownmenu .submenu {
//     color: #FFFFFF;
//     display: block;
//     font: 16px sans-serif;
//     padding: 0;
//     text-decoration: none;
//     -webkit-transition: all .25s ease;
//     -moz-transition: all .25s ease;
//     -ms-transition: all .25s ease;
//     -o-transition: all .25s ease;
//     transition: all .25s ease;
// }

.icon-triangle {
  margin-left: 8px;
  transition: all 0.25s ease;
}

/* 单个菜单样式 */
.menu-item-t {
  height: 50px;
  line-height: 50px;
  position: relative;
  transform: skew(-20deg);
  background: linear-gradient(to right, #c4d7fa, #cbddfc);
  color: #424a6b;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.line-color {
  background: linear-gradient(to right, #e0e9fb, #a5c5fa);
}
.trapezoid-menu {
  height: 50px;
  line-height: 50px;
  width: 120px;
  position: relative;
  left: -10px;
  clip-path: polygon(18px 0%, 100% 0%, 100% 100%, 0 100%);
  background: linear-gradient(to right, #e0e9fb, #a5c5fa);
  color: #424a6b;
  text-align: center;
  cursor: pointer;
  font-weight: 700;
}
.li-img {
  width: 30px;
  transform: skew(20deg);
  margin-right: 8px;
}

.submenu {
  left: 0;
  opacity: 1;
  position: absolute;
  top: 52px;
  visibility: hidden;
  z-index: 99999;
  background: rgba(#0076b9, 0.6);
  color: #ffffff;
  display: block;
  padding: 0;
  text-decoration: none;
  -webkit-transition: all 0.25s ease;
  -moz-transition: all 0.25s ease;
  -ms-transition: all 0.25s ease;
  -o-transition: all 0.25s ease;
  transition: all 0.25s ease;

  .menu-item {
    margin: 0 10px;
    background-image: none;
    width: auto;
    font-size: 16px;
    border-bottom: 1px solid rgba(#ffffff, 0.2);
  }
}

.menu-item:hover {
  color: #83e9ff;
  cursor: pointer;

  .icon-triangle {
    transform: rotate(180deg);
  }
}

li:hover ul.submenu {
  opacity: 1;
  top: 52px;
  /* adjust this as per top nav padding top & bottom comes */
  visibility: visible;
}

// .submenu>.menu-item:active {
//         // background-color: red;
//         // visibility: hidden !important;
//         opacity: 0;
//         height: 0;
//         width: 0;
//         -webkit-transition: all .1s ease;
//         -moz-transition: all .1s ease;
//         -ms-transition: all .1s ease;
//         -o-transition: all .1s ease;
//         transition: all .1s ease;
// }
</style>
